import {MutationTree} from "vuex";
import {QuantityLimitState} from "@/store/settings/quantity_limits/types";

export const mutations: MutationTree<QuantityLimitState> = {
    setQuantityLimit:(state, payload) => {
        state.quantityLimit = payload
    },
    setQuantityLimitItem:(state, payload) => {
        state["quantityLimitItem"] = payload
    }
}
